/* One-Time / Subscribe toggle behaviour. Uses event delegation so it also works in quick-view modals. */
(function () {
  if (window.__spToggleInit) return;
  window.__spToggleInit = true;

  function setMode(root, mode) {
    var form = root.closest('form');
    if (!form) return;
    form.setAttribute('data-sub-mode', mode);

    var tabs = root.querySelectorAll('[data-sp-mode]');
    for (var i = 0; i < tabs.length; i++) {
      var active = tabs[i].getAttribute('data-sp-mode') === mode;
      tabs[i].classList.toggle('is-active', active);
      tabs[i].setAttribute('aria-pressed', active ? 'true' : 'false');
    }

    var input = root.querySelector('[data-sp-input]');
    if (input) input.disabled = mode !== 'subscribe';

    var notes = root.querySelectorAll('[data-sp-note]');
    for (var j = 0; j < notes.length; j++) notes[j].hidden = mode !== 'subscribe';

    /* Subscribe offers only the 1st variant (1 Month Supply): select it. */
    if (mode === 'subscribe') {
      var first = form.querySelector('.variant-list input[name="id"], .plans-grid input[name="id"]');
      if (first && !first.disabled) first.checked = true;
    }
  }

  document.addEventListener('click', function (e) {
    var tab = e.target.closest ? e.target.closest('[data-sp-mode]') : null;
    if (!tab) return;
    var root = tab.closest('[data-sp-toggle]');
    if (!root) return;
    e.preventDefault();
    setMode(root, tab.getAttribute('data-sp-mode'));
  });

  document.addEventListener('change', function (e) {
    var select = e.target.closest ? e.target.closest('[data-sp-select]') : null;
    if (!select) return;
    var root = select.closest('[data-sp-toggle]');
    var input = root && root.querySelector('[data-sp-input]');
    if (input) input.value = select.value;
  });
})();